// extracted by mini-css-extract-plugin
export var applyHoverStyle = "zDswe";
export var badgeContainer = "maNs2";
export var blackColor = "F_JTb";
export var greyColor = "EpHo6";
export var primaryColor = "oJOwX";